const content = [
  {
    id: 1,
    title: "Our Courses",
    body: "Whether you are starting now or a professional on IT, we help to change your career. Our process is designed to lead each and every student to a successful professional career in the emerging global marketplace. We offer programs that enable you to level up.",
    image: "courses.jpg",
  },
  {
    id: 2,
    title: "Learning-by-doing",
    body: "You will receive one-to-one (1:1) attention in our mentor class. You can reach out to experts and get your questions answered 24/7. We help by giving you the shortcuts and coaching tips you need to get job-ready faster than any other IT Bootcamp.",
    image: "learning.jpg",
  },
  {
    id: 3,
    title: "Meet Our Alumni",
    body: "e’ve upskilled over 3,000 students and graduates from around the world. They’re successfully working in the IT industry and part of our alumni network. Meet our alumni online and hear their success stories. Learn how you can become a member of the Clarusway family and get the career you’ve always dreamed of – it’s your turn to shine!",
    image: "meet.jpg",
  },
];

export default content;
